import api from "../distflowAPI/api";

export const setSession = (response) => {
  const accessToken = response.data.access;
  const authToken = `Bearer ${accessToken}`;
  localStorage.setItem("accessToken", authToken);
  api.defaults.headers.common.Authorization = authToken;
};
